import apiFetch from '../apiFetch'

export default function (token, financingTypeId, companyId) {
  return apiFetch({ endPoint: `FinancingType/${financingTypeId}/${companyId}/Recover`, method: 'PUT', token: token })
}
